import React from "react";
import { Link } from "@quintype/components";
import { object, array, number, string, bool } from "prop-types";
import "./story-card11.m.css";
import CardImage from "../../atoms/cardimage";
import Headline from "../../atoms/headline";

import { format } from "date-fns";
import { kn } from "date-fns/locale";
import VideoIcon from "../../atoms/icons/video-icon";

function StoryCard11({ story, aspectRatio, imageType, headerType, headerLevel, showRedDot }) {
  const publishedDate = format(new Date(story["first-published-at"]), "d MMMM yyyy, H:mm", { locale: kn });

  return (
    <Link href={story.url}>
      <div styleName="story-card11">
        <div styleName="story-card11-image-wrapper">
          <CardImage story={story} aspectRatio={aspectRatio} imageType={imageType} renderedWidth={720} widths={[700]} />
          {story["story-template"] && story["story-template"] === "video" ? (
            <div styleName="video-icon">
              <VideoIcon />
            </div>
          ) : null}
        </div>
        <Headline
          text={story.headline}
          headerType={headerType}
          headerLevel={headerLevel}
          story={story}
          width={20}
          height={20}
          showRedDot={showRedDot}
          styleName
        />
      </div>
      <div styleName="published-date">{publishedDate} IST</div>
      <div styleName="story-card-divider"></div>
    </Link>
  );
}
StoryCard11.defaultProps = {
  aspectRatio: [16, 9],
  imageType: "image16x9",
  headerType: 2,
  headerLevel: 2,
  showRedDot: false
};

StoryCard11.propTypes = {
  story: object.isRequired,
  aspectRatio: array,
  imageType: string,
  headerType: number,
  headerLevel: number,
  showRedDot: bool
};
export default StoryCard11;
